import { render, staticRenderFns } from "./SfSelect.vue?vue&type=template&id=fca3c658&"
import script from "./SfSelect.vue?vue&type=script&lang=js&"
export * from "./SfSelect.vue?vue&type=script&lang=js&"
import style0 from "./SfSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports